export enum FoodTimeEnum {
  BREAKFAST = 'BREAKFAST',
  MEAL = 'MEAL',
  DINNER = 'DINNER',
  SNACK_ONE = 'SNACK_ONE',
  SNACK_TWO = 'SNACK_TWO',
}
